import { Injectable } from '@angular/core';
import { AbstractFeatureFlags } from '@fmnts/common/feature-flags';
import { Customer } from '@formunauts/shared/domain';

@Injectable({
  providedIn: 'root',
})
export class CustomerFeatureService extends AbstractFeatureFlags<Customer.Features> {}
